export class FTEDetailsDataViewRequest {
    ParamID: string;
    CreatedOnFrom: string;
    CreatedOnTo: string;
    CouncelorActionOnFrom: string;
    CouncelorActionOnTo: string;
    PartnerActionOnFrom: string;
    PartnerActionOnTo: string;
    LastIncrementDateFrom: string;
    LastIncrementDateTo: string;
    EmpContractEndDateFrom: string;
    EmpContractEndDateTo: string;
    FTEID: string;
    EmpLocationText: string;
    EmpName: string;
    EmpEmail: string;
    ServiceLineText: string;
    CouncelorName: string;
    EmpTitle: string;
    ManagerName: string;
    PartnerName: string;
    CurrUserGPN: string;
    IDList: string;
    PageNumber: string;
    IsExport: boolean;
    IsAdmin: boolean;
    RequestStatusID: string;
    EmpGPN: string;
  
    constructor(init?: Partial<FTEDetailsDataViewRequest>) {
      Object.assign(this, init);
    }
  }
